/* edit-history-modal.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./edit-history-modal.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Fragment, lazy, Suspense } from 'react';
import { useIntl } from 'react-intl-next';
import EmptyState from '@atlaskit/empty-state';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import Blog16Icon from '@atlaskit/icon-object/glyph/blog/16';
import Page16Icon from '@atlaskit/icon-object/glyph/page/16';
import OpenFolderIcon from '@atlaskit/icon/core/folder-open';
import FileIcon from '@atlaskit/icon/core/migration/file';
import OfficeBuildingIcon from '@atlaskit/icon/core/migration/office-building';
import DocumentsIcon from '@atlaskit/icon/core/migration/pages--documents';
import QuoteIcon from '@atlaskit/icon/core/migration/quotation-mark--quote';
import { OpenFolderIcon as LegacyOpenFolderIcon } from '@atlaskit/legacy-custom-icons';
import Link from '@atlaskit/link';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import { Box, Inline, Stack } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner';
import TimeAgo from '@atlassian/mpt-timeago';
import { useAIAnswerContext } from '../../../../ai-answer-dialog/ai-answer-context';
import { EditedDefinitionScope } from '../types';
import { messages } from './messages';
import { useDefinitionEditHistory } from './useDefinitionEditHistory';
var styles = {
  loadingSpinner: "_1e0c1txw _1bah1h6o _4t3i1osq _1bsb1osq",
  editHistoryWrapper: "_zulppxbi _11c82smr _1e0c1txw _2lx21bp4 _n3tdv47k",
  editHistoryDescription: "_zulp1b66 _syazi7uo",
  editedDefinitionCardContainer: "_zulpu2gc _1e0c1txw _2lx21bp4",
  editedDefinitionScopeText: "_1e0c1txw _2lx2vrvc _4cvr1h6o _syaz1rpy",
  editedDefinitionCard: "_2rkoy0do _zulppxbi _189ee4h9 _1dqonqa1 _1h6dmuej _1e0c1txw _2lx2vrvc _4cvr1y6m _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
  editedDefinitionAvatar: "_2rko1tk5",
  editedDefinitionCardBody: "_11c82smr _zulputpp _1e0c1txw _2lx21bp4 _1bsb1osq _syazi7uo",
  editedDefinitionCardHeaderWrapper: "_zulpze3t _1e0c1txw _2lx21bp4",
  editedDefinitionCardHeader: "_zulp1b66 _1e0c1txw _2lx2vrvc _4cvr1h6o _syazazsu _otyru2gc",
  editedDefinitionCardEditor: "_k48p1pd9 _syazi7uo",
  editedDefinitionCardReference: "_1e0c1txw _4cvr1h6o",
  editedDefinitionCardReferenceTitle: "_18u01b66",
  editedDefinitionCardHeaderSpacer: "_1bsb1osq _syaz3iw8 _19pkv77o _otyridpf"
};
var MarkdownRenderer = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "react-markdown" */'react-markdown').then(function (_ref) {
    var ReactMarkdown = _ref.default;
    return {
      default: ReactMarkdown
    };
  });
});
var ScopeDescription = function ScopeDescription(_ref2) {
  var scope = _ref2.scope;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var scopeDescription = '';
  var ScopeIcon;
  switch (scope) {
    case EditedDefinitionScope.ORGANIZATION:
      scopeDescription = formatMessage(messages.readingAidsEditHistoryVisibilityTextOrg);
      ScopeIcon = OfficeBuildingIcon;
      break;
    case EditedDefinitionScope.SPACE:
      scopeDescription = formatMessage(messages.readingAidsEditHistoryVisibilitySpace);
      ScopeIcon = DocumentsIcon;
      break;
    case EditedDefinitionScope.PAGE:
      scopeDescription = formatMessage(messages.readingAidsEditHistoryVisibilityPage);
      ScopeIcon = FileIcon;
      break;
    case EditedDefinitionScope.BLOGPOST:
      scopeDescription = formatMessage(messages.readingAidsEditHistoryVisibilityBlog);
      ScopeIcon = QuoteIcon;
      break;
    case EditedDefinitionScope.PROJECT:
      scopeDescription = formatMessage(FeatureGates.getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? messages.readingAidsEditHistoryVisibilityProjectGalaxia : messages.readingAidsEditHistoryVisibilityProject);
      ScopeIcon = function ScopeIcon() {
        return /*#__PURE__*/React.createElement(OpenFolderIcon, {
          color: "var(--ds-icon, #292A2E)",
          label: "",
          LEGACY_fallbackIcon: LegacyOpenFolderIcon,
          LEGACY_size: "medium",
          LEGACY_margin: "0 0 0 ".concat("var(--ds-space-negative-050, -4px)")
        });
      };
      break;
    default:
      return null;
  }
  return /*#__PURE__*/React.createElement(Inline, {
    xcss: styles.editedDefinitionScopeText,
    space: "space.050"
  }, scopeDescription, " ", /*#__PURE__*/React.createElement(ScopeIcon, {
    label: ""
  }));
};
export var DefinitionEditHistory = function DefinitionEditHistory(_ref3) {
  var curatedDefinitionScopeConfig = _ref3.curatedDefinitionScopeConfig,
    onClose = _ref3.onClose;
  var _useIntl2 = useIntl(),
    formatMessage = _useIntl2.formatMessage;
  var _useAIAnswerContext = useAIAnswerContext(),
    query = _useAIAnswerContext.commonAttributes.query;
  var _useDefinitionEditHis = useDefinitionEditHistory({
      query: query,
      curatedDefinitionScopeConfig: curatedDefinitionScopeConfig
    }),
    definitions = _useDefinitionEditHis.definitions,
    loading = _useDefinitionEditHis.loading;
  var hasError = definitions.length === 0 && !loading;
  return /*#__PURE__*/React.createElement(Modal, {
    onClose: onClose,
    height: 600
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    hasCloseButton: true
  }, /*#__PURE__*/React.createElement(ModalTitle, null, formatMessage(messages.readingAidsEditHistoryHeader))), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(Stack, {
    xcss: styles.editHistoryWrapper
  }, /*#__PURE__*/React.createElement(Inline, {
    xcss: styles.editHistoryDescription
  }, formatMessage(messages.readingAidsEditHistoryDescription, {
    queryText: /*#__PURE__*/React.createElement("b", null, query)
  })), hasError || loading ? /*#__PURE__*/React.createElement(Box, {
    xcss: styles.loadingSpinner
  }, loading && /*#__PURE__*/React.createElement(Spinner, {
    size: "large",
    testId: "definition-history-loading-spinner"
  }), hasError && /*#__PURE__*/React.createElement(EmptyState, {
    header: formatMessage(messages.readingAidsEditHistoryCardErrorText)
  })) : definitions.map(function (item, index) {
    var _item$editor, _item$editor2, _item$confluenceEntit;
    return /*#__PURE__*/React.createElement(Box, {
      xcss: styles.editedDefinitionCardContainer,
      key: "edited-definition-history-card-".concat(index)
    }, /*#__PURE__*/React.createElement(ScopeDescription, {
      scope: item.scope
    }), /*#__PURE__*/React.createElement(Box, {
      xcss: styles.editedDefinitionCard
    }, /*#__PURE__*/React.createElement(Box, {
      xcss: styles.editedDefinitionAvatar
    }, /*#__PURE__*/React.createElement("img", {
      src: ((_item$editor = item.editor) === null || _item$editor === void 0 ? void 0 : _item$editor.picture) || '',
      width: "32px",
      height: "32px"
    })), /*#__PURE__*/React.createElement(Box, {
      xcss: styles.editedDefinitionCardBody
    }, /*#__PURE__*/React.createElement(Box, {
      xcss: styles.editedDefinitionCardHeaderWrapper
    }, /*#__PURE__*/React.createElement(Inline, {
      xcss: styles.editedDefinitionCardHeader
    }, formatMessage(messages.readingAidsEditHistoryCardEdited, {
      editorName: /*#__PURE__*/React.createElement(Inline, {
        xcss: styles.editedDefinitionCardEditor
      }, ((_item$editor2 = item.editor) === null || _item$editor2 === void 0 ? void 0 : _item$editor2.name) || '')
    }), ' ∙ ', /*#__PURE__*/React.createElement(TimeAgo, {
      date: Number(item.createdAt) * 1000
    })), /*#__PURE__*/React.createElement("hr", {
      role: "presentation",
      className: ax([styles.editedDefinitionCardHeaderSpacer])
    })), /*#__PURE__*/React.createElement("span", {
      "data-testid": "rendered-markdown-definition-".concat(index)
    }, /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement(Fragment, null)
    }, /*#__PURE__*/React.createElement(MarkdownRenderer, {
      disallowedElements: ['img']
    }, item.definition))), item.referenceUrl && ((_item$confluenceEntit = item.confluenceEntity) === null || _item$confluenceEntit === void 0 ? void 0 : _item$confluenceEntit.title) && /*#__PURE__*/React.createElement(Box, {
      xcss: styles.editedDefinitionCardReference
    }, /*#__PURE__*/React.createElement(Link, {
      appearance: "subtle",
      target: "_blank",
      href: item.referenceUrl
    }, item.confluenceEntity.type === 'BLOG_POST' ? /*#__PURE__*/React.createElement(Blog16Icon, {
      label: ""
    }) : /*#__PURE__*/React.createElement(Page16Icon, {
      label: ""
    }), /*#__PURE__*/React.createElement(Inline, {
      xcss: styles.editedDefinitionCardReferenceTitle
    }, item.confluenceEntity.title || ''))))));
  }))), /*#__PURE__*/React.createElement(ModalFooter, null));
};